import styled from "styled-components"

export const PromoWrapper = styled.div`
  position: relative;
`

const PromoContainer = styled(PromoWrapper)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 130px;
  min-height: 30px;
  padding: 3px 0 3px 10px;
  font-weight: bold;
  flex: 0 0 130px;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: calc(100% + 20px);
    height: 100%;
    background: var(--promo-bg);
    clip-path: polygon(0 0, 100% 0, calc(100% - 5px) 100%, 5px 100%);
  }

  span {
    position: relative;
    display: inline-block;
    width: 100%;
    font-size: 11px;
    line-height: 12px;
    letter-spacing: -0.1px;
    text-align: center;
    z-index: 1;
  }
`

export default PromoContainer
